export const productSortItems: string[] = [
  'bestSelling',
  'newest',
];
